
import BarcodeScanBase from "./components/Base";

export default function BarcodeScanFeature() {
  return (
    <div>
      <BarcodeScanBase />
    </div>
  );
}
